import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import LayoutAuth from '../../components/layoutAuth';
import { authService } from '../../services/auth';

export default function RegisterPage({ onRegister }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [organizationName, setOrganizationName] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const submit = (e) => {
    e.preventDefault();
    setError('');
    authService.register({ email, password, organization_name: organizationName }, (res) => {
      localStorage.setItem('accessToken', res.data.access);
      localStorage.setItem('refreshToken', res.data.refresh);
      onRegister();
      navigate('/');
    }, (err) => {
      const data = err?.response?.data;
      if (typeof data === 'string') {
        setError(data);
        return;
      }
      if (data?.detail) {
        setError(data.detail);
        return;
      }
      if (data && typeof data === 'object') {
        const [field, value] = Object.entries(data)[0] || [];
        if (field && value) {
          setError(Array.isArray(value) ? value[0] : value);
          return;
        }
      }
      setError('Registration failed. Please try again.');
    });
  };

  return (
    <LayoutAuth>
      <h1 className="text-2xl font-semibold mb-6">Create account</h1>
      <form onSubmit={submit} className="space-y-4">
        <input type="text" placeholder="Organization name" value={organizationName} onChange={(e) => setOrganizationName(e.target.value)} className="w-full p-3 rounded-lg bg-theme-secondary" required />
        <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full p-3 rounded-lg bg-theme-secondary" required />
        <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full p-3 rounded-lg bg-theme-secondary" required />
        {error && <p className="text-red-400 text-sm">{error}</p>}
        <button type="submit" className="w-full py-3 rounded-lg bg-theme-primary text-theme-button font-medium">Register</button>
      </form>
      <p className="mt-4 text-sm opacity-70"><Link to="/login/" className="text-theme-primary">Already have an account?</Link></p>
    </LayoutAuth>
  );
}
